import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateMarket } from 'services/api/requests/market';

import { mapErrorToToastProps } from '../../../utils/forms/mapErrorToToastProps';

export const useEditMarket = (id, body, onClose) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => updateMarket(id, body), {
		onSuccess: sucess => {
			queryClient.invalidateQueries(['mercado-list']);
			queryClient.invalidateQueries(['mercadoById', id]);

			toast({
				title: 'Atualizado com sucesso!',
				description: 'Mercado atualizado com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});

			onClose?.();
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao editar Mercado!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
